import React from 'react';
import { View, Text, ScrollView, Platform } from 'react-native';
import CreateActionPlanForm from '../components/CreateActionPlanForm';
import { useCreateNewActionPlan } from '../hooks/useCreateNewActionPlan';
import { styles } from '../styles/createNewActionPlan.styles';
import { FORM_DEFAULTS } from '../constants';
import type { CreateNewActionPlanProps } from '../types';
import { useTheme } from '../../../theme';

/**
 * CreateNewActionPlan
 *
 * Page component for creating a new action plan.
 * Manages form submission and cancellation handlers.
 */
const CreateNewActionPlan: React.FC<CreateNewActionPlanProps> = ({ onCreated, onCancel }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';
  const { handleSubmit, handleCancel } = useCreateNewActionPlan(onCreated, onCancel);

  return (
    <View style={[styles.page, isDark && { backgroundColor: colors.background.page }]}>
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        scrollEnabled={true}
        bounces={true}
      >
        <View style={styles.headerWrapper}>
          <Text style={[styles.heading, isDark && { color: colors.text.primary }]}>New Action Plan</Text>
        </View>
        <View style={styles.formWrapper}>
          <CreateActionPlanForm data={{}} type="create" onSubmit={handleSubmit} onCancel={handleCancel} />
        </View>
      </ScrollView>
    </View>
  );
};

export default CreateNewActionPlan;
